export const TAB_INDICES = {
  MAIL_PREVIEW: 0,
  PROJECT_CONCLUSION: 1,
} as const;
